export default __webpack_public_path__ + "static/media/RUPABARNA.2b26915e.png";